import { I18nLabel, SelectOption } from 'types/base';
import { LANGUAGE_MAP } from 'constant/language';

export const weekDetail = {
  [LANGUAGE_MAP.EN]: ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'],
  [LANGUAGE_MAP.JA]: [
    '日曜日',
    '月曜日',
    '火曜日',
    '水曜日',
    '木曜日',
    '金曜日',
    '土曜日',
  ],
  [LANGUAGE_MAP.FR]: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  [LANGUAGE_MAP.ZH_CN]: [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六',
  ],
};

export const TICKET_STORE_TEXT_EN =
  'All in-store purchases are final and cannot be returned or exchanged.';

export const TICKET_STORE_TEXT_JA =
  'お買い求め頂きまして誠に有難うございます。店頭でご購入いただいた商品は、お客様都合による返品・交換はご遠慮いただいております。';

export const TICKET_STORE_TEXT_FR =
  'Tous les achats sur place sont définitifs et ne peuvent pas être retournés ni échangés.';

export const TICKET_STORE_TEXT_ZH_CN =
  '所有店内购买均为最终购买，不可退货或换货。';

export const TICKET_PAYMENT_NOTICE_EN =
  'Payment must be completed within 7 days. Unpaid orders will be canceled and deposits will not be refunded.';

export const TICKET_PAYMENT_NOTICE_JA =
  'お支払いは7日以内にお願いいたします。期日までにお支払いが確認できない場合、ご注文はキャンセルとなり、デポジットは返金いたしかねます。';

export const TICKET_PAYMENT_NOTICE_FR =
  'Le paiement doit être effectué dans les 7 jours. Les commandes non payées seront annulées et les dépôts ne seront pas remboursés.';

export const TICKET_PAYMENT_NOTICE_ZH_CN =
  '支付必须在7天内完成。未付款的订单将被取消，押金将不予退还。';

export const TICKET_ACCESSORIES_CONFIRM_EN =
  'Signature confirms accessories checked together.';

export const TICKET_ACCESSORIES_CONFIRM_JA = '付属品の確認を行いました';

export const TICKET_ACCESSORIES_CONFIRM_FR =
  'La signature confirme que les accessoires ont été vérifiés ensemble.';

export const TICKET_ACCESSORIES_CONFIRM_ZH_CN = '附带品确认一起签字。';

const normalizeAccessoryValues = (value?: string | string[]) => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }

  const trimmed = value.trim();
  if (!trimmed) return [];

  return trimmed
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

export const getReceiptAccessories = (
  value: string | string[] | undefined,
  lang: (typeof LANGUAGE_MAP)[keyof typeof LANGUAGE_MAP],
  accessoryOptions: (SelectOption & I18nLabel)[] = [],
) => {
  return normalizeAccessoryValues(value).map((item) => {
    const accessory = accessoryOptions.find(
      (option) => String(option.value) === item,
    );

    if (!accessory) return item;

    if (lang === LANGUAGE_MAP.ZH_CN)
      return accessory.labelCn || accessory.label || item;

    if (lang === LANGUAGE_MAP.JA)
      return accessory.labelJa || accessory.label || item;

    return accessory.labelEn || accessory.label || item;
  });
};
